import SectionTabs from './SectionTabs';

export default SectionTabs;
